import { render, staticRenderFns } from "./note-files-create.html?vue&type=template&id=5f9b3800&scoped=true&"
import script from "./note-files-create.js?vue&type=script&lang=js&"
export * from "./note-files-create.js?vue&type=script&lang=js&"
import style0 from "./note-files-create.css?vue&type=style&index=0&id=5f9b3800&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9b3800",
  null
  
)

export default component.exports